const list = {
  // =================================================================================================================
  components() {
    return [
      {
        component: "search-start-end",
        label: "점검일",
        value: "date",
        query: { ss: "startDate", ee: "endDate" },
        options: {
          default: { sd: "", ed: "" },
          gridTemplateColumns: "114px 278px",
        },
      },
      {
        component: "search-select",
        label: "점검종류",
        value: "type",
        query: { type: "select" },
        options: {
          items: ["정기", "수시"],
          default: "",
          gridTemplateColumns: "114px 178px",
        },
      },

      { component: "empty-space" },

      {
        component: "search-select-multi",
        label: "점검대상",
        value: "target",
        query: { target: "select" },
        options: {
          items: ["대기(일반)", "대기(총량)", "비산먼지", "비산배출(Haps)", "수질", "하수", "폐기물", "토양", "악취", "소음진동", "화학물질", "잔류성유기오염물질"],
          default: [],
          gridTemplateColumns: "114px 278px",
        },
      },
      {
        component: "search-select",
        label: "시료채취",
        value: "check",
        query: { check: "select" },
        options: {
          items: ["O", "X"],
          default: "",
          gridTemplateColumns: "114px 178px",
        },
      },
      {
        component: "search-select",
        label: "지적사항",
        value: "indicate",
        query: { indicate: "select" },
        options: {
          items: ["행정처분", "벌금", "과태료", "권고", "없음"],
          default: "",
          gridTemplateColumns: "114px 178px",
        },
      },
    ];
  },
  getConditions: (nav) => {
    const conditions = [];
    const search = nav.value;

    //  검색일
    if (search.date) {
      conditions.push({ key: "body.점검일", operator: ">=", value: search.date.startDate });
      conditions.push({ key: "body.점검일", operator: "<", value: search.date.endDate ? new Date(search.date.endDate).addDays(1).format("yyyy-MM-dd") : "" });
    }

    if (search.type) {
      conditions.push({ key: "body.점검종류", operator: "=", value: search.type });
    }

    if (search.target && search.target.length > 0) {
      conditions.push({ key: "body.체크점검대상[%]", operator: "IN", value: search.target });
    }

    if (search.check) {
      const check = search.check === "O" ? "유" : "무";
      conditions.push({ key: "body.시료채취유무", operator: "=", value: check });
    }

    if (search.indicate) {
      conditions.push({ key: "body.체크지적사항", operator: "LIKE", value: `%${search.indicate}%` });
    }

    return conditions;
  },

  // =================================================================================================================
  getHead: () => {
    return [
      {
        name: "사업장명",
        key: "body.stdInfo.field_name",
      },
      {
        name: "점검종류",
        key: "body.점검종류",
      },
      {
        name: "점검대상",
        key: "body.체크점검대상",
      },
      {
        name: "점검일",
        key: "body.점검일",
      },
      {
        name: "점검기관",
        key: "body.점검기관",
      },
      {
        name: "시료채취",
        key: "body.시료채취유무",
      },
      {
        name: "지적사항",
        key: "body.체크지적사항",
      },
    ];
  },
  getCol: (index, value, func) => {
    try {
      switch (index) {
        case 0:
          return func.getContent(value).stdInfo.field_name; // 사업장명
        case 1:
          return func.getContent(value).점검종류; // 점검종류
        case 2:
          return func.getContent(value).체크점검대상.join(", "); // 체크점검대상
        case 3:
          return func.getContent(value).점검일; // 점검일
        case 4:
          return func.getContent(value).점검기관.join(", "); // 점검기관
        case 5:
          return func.getContent(value).시료채취유무 === "유" ? "O" : "X"; // 시료채취유무
        case 6:
          return func.getContent(value).체크지적사항; // 지적사항
      }
    } catch (e) {
      /*ignore*/
    }
    return "";
  },
  getSearchKeyValue: (nav) => {},
  getSearchKeyword: (nav) => {},
};
export default list;
